<script setup lang="ts">
import { computed } from 'vue';
import { useHelp } from './useHelp';

const { currentArticleUrl, helpData } = useHelp();

const texts = computed(() => helpData.value.texts);
</script>

<template>
    <section class="flex flex-1 flex-col gap-4 overflow-hidden bg-white">
        <iframe
            v-if="currentArticleUrl"
            :key="currentArticleUrl"
            :src="currentArticleUrl"
            class="flex-1 border-0"
            loading="lazy"
            referrerpolicy="no-referrer"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            allow="autoplay; fullscreen"
            allowfullscreen
            :title="texts.article.iframeTitle"
        ></iframe>
        <div
            v-else
            class="flex flex-1 items-center justify-center px-4 text-center text-sm text-gray-500"
        >
            <span>
                {{ texts.article.placeholder }}
            </span>
        </div>
    </section>
</template>
